export const enum OSName {
  Android = 'Android',
  Windows = 'Windows',
  Linux = 'Linux',
  Unix = 'Unix',
  IOS = 'iOS',
  MacOS = 'macOS'
}

const enum OSKeyWord {
  Android = 'Android',
  Windows = 'Windows',
  Linux = 'Linux',
  Unix = 'X11',
  IPhoneOS = 'iPhone OS',
  AppleIPhone = 'Apple-iPhone',
  MacOS = 'Mac OS'
}

// Порядок важен, например для Android строка userAgent содержит "(Linux; Android 10; K)"
const osMap = [
  { name: OSName.Android, keyWord: OSKeyWord.Android },
  { name: OSName.Windows, keyWord: OSKeyWord.Windows },
  { name: OSName.Linux, keyWord: OSKeyWord.Linux },
  { name: OSName.Unix, keyWord: OSKeyWord.Unix },
  { name: OSName.IOS, keyWord: OSKeyWord.IPhoneOS },
  { name: OSName.IOS, keyWord: OSKeyWord.AppleIPhone },
  { name: OSName.MacOS, keyWord: OSKeyWord.MacOS }
]

const getInfoBySeparators = (
  source: string,
  leftSeparator?: string,
  rightSeparator?: string,
  leftShift: number = 1
): string => {
  const rightPart = source.split(leftSeparator!)[leftShift] || ''
  return rightPart.split(rightSeparator!)[0].trim()
}

const getOsVersion = (osKeyWord: string, osDeviceInfo: string): string => {
  switch (osKeyWord) {
    case OSKeyWord.Android:
    case OSKeyWord.Windows: {
      return getInfoBySeparators(osDeviceInfo, osKeyWord, ';')
    }
    case OSKeyWord.IPhoneOS: {
      return getInfoBySeparators(osDeviceInfo, `${osKeyWord} `, ' ')
    }
    case OSKeyWord.AppleIPhone: {
      return getInfoBySeparators(osDeviceInfo, osKeyWord, '/')
    }
    case OSKeyWord.MacOS: {
      return getInfoBySeparators(osDeviceInfo, `${osKeyWord} `, ')')
    }
    case OSKeyWord.Linux:
    case OSKeyWord.Unix: {
      return getInfoBySeparators(osDeviceInfo, `${OSKeyWord.Unix}; `, ';')
    }
    default: {
      return ''
    }
  }
}

const getDeviceModel = (osKeyWord: string, osDeviceInfo: string): string => {
  switch (osKeyWord) {
    case OSKeyWord.Android: {
      return (
        `${OSName.Android} ` + getInfoBySeparators(osDeviceInfo, osKeyWord, ';')
      )
    }
    case OSKeyWord.IPhoneOS: {
      return getInfoBySeparators(osDeviceInfo, undefined, ';', 0)
    }
    case OSKeyWord.AppleIPhone: {
      return getInfoBySeparators(osDeviceInfo, undefined, '/', 0)
    }
    case OSKeyWord.Windows:
    case OSKeyWord.Linux:
    case OSKeyWord.Unix:
    case OSKeyWord.MacOS: {
      return 'PC'
    }
    default: {
      return ''
    }
  }
}

type UserAgentData = {
  osName: string
  osVersion: string
  deviceModel: string
}

export const getUserAgentData = (userAgent: string): UserAgentData => {
  const userAgentData = {
    osName: '',
    osVersion: '',
    deviceModel: ''
  }

  if (!userAgent) {
    return userAgentData
  }

  const osDeviceInfo = getInfoBySeparators(userAgent, '(', ')')

  for (const { name, keyWord } of osMap) {
    if (userAgent.includes(keyWord)) {
      userAgentData.osName = name
      userAgentData.osVersion = getOsVersion(keyWord, osDeviceInfo)
      userAgentData.deviceModel = getDeviceModel(keyWord, osDeviceInfo)
      break
    }
  }

  return userAgentData
}
